export const SYNDICATED_MONETIZATION_TOAST_ID = 'syndicated-monetization-toast';

export type SyndicatedLine = {
  applicationId: number;
  productLineId: number;
  productLineCode: string;
  productLabel: string;
  cuit: string;
  companyName: string;
  currencyCode: string;
  lineAmount: number;
};

export function mapSyndicatedLine(raw: Record<string, unknown>): SyndicatedLine {
  return {
    applicationId: Number(raw.application_id ?? raw.applicationId),
    productLineId: Number(raw.product_line_id ?? raw.productLineId),
    productLineCode: String(raw.product_line_code ?? raw.productLineCode ?? ''),
    productLabel: String(raw.product_label ?? raw.productLabel ?? ''),
    cuit: String(raw.cuit ?? ''),
    companyName: String(raw.company_name ?? raw.companyName ?? ''),
    currencyCode: String(raw.currency_code ?? raw.currencyCode ?? 'ARS'),
    lineAmount: Number(raw.line_amount ?? raw.lineAmount ?? 0),
  };
}

export function mapSyndicatedLines(raw: unknown): SyndicatedLine[] {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((item) => mapSyndicatedLine((item ?? {}) as Record<string, unknown>))
    .filter((row) => Number.isFinite(row.applicationId) && row.applicationId > 0);
}

export type SyndicatedPreviewInstallmentRow = {
  installment_number: number;
  due_date: string;
  activo: string;
  amortization: number;
  interest: number;
  amount: number;
  final_balance: number;
};

/** Maps preview API rows and computes running Saldo Final from line amount. */
export function mapSyndicatedPreviewInstallments(
  rawRows: unknown,
  lineAmount: number
): SyndicatedPreviewInstallmentRow[] {
  if (!Array.isArray(rawRows)) return [];
  let remaining = Number(lineAmount) || 0;
  return rawRows.map((item) => {
    const row = (item ?? {}) as Record<string, unknown>;
    const amortization = Number(row.amortization ?? 0);
    const interest = Number(row.interest ?? 0);
    const amount = Number(row.amount ?? amortization + interest);
    remaining = Math.round((remaining - amortization) * 100) / 100;
    const dueRaw = row.due_date ?? row.dueDate ?? '';
    return {
      installment_number: Number(row.installment_number ?? row.installmentNumber ?? 0),
      due_date: String(dueRaw).split('T')[0],
      activo: 'Pendiente',
      amortization,
      interest,
      amount,
      final_balance: remaining,
    };
  });
}
